import axios from "axios";

const requisicaoAssinatura = async function (bodyreq) {
  try {
      console.log("bodyreq", bodyreq)
      const url = process.env.VUE_APP_ALIANCAADM_DOCUSIGN + '/requisicaoAssinatura?api-key=' + process.env.VUE_APP_ALIANCAADM_DOCUSIGN_API_KEY;
      const { data } = await axios.post(url, bodyreq);
      return data;
  } catch (e) {
    console.log(e)
  }
};

export default requisicaoAssinatura;
